/**
 * @author LB
 * @description 企业路由
 */
export default [
  {
    path: '/enterprise/enterpriseManage',
    name: 'enterprise_enterpriseManage',
    meta: {
      title: '企业管理',
      pageId: 'enterpriseManage',
      pageName: '企业管理',
      parentId: 'enterprise',
      parentName: '企业',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/enterprise/enterpriseManage/enterpriseManage'], resolve),
  },
  {
    path: '/enterprise/brandManage',
    name: 'enterprise_brandManage',
    meta: {
      title: '品牌管理',
      pageId: 'brandManage',
      pageName: '品牌管理',
      parentId: 'enterprise',
      parentName: '企业',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/enterprise/brandManage/brandManage'], resolve),
  },
  {
    path: '/enterprise/storeManage/storeList',
    name: 'enterprise_storeList',
    meta: {
      title: '门店列表',
      pageId: 'storeList',
      pageName: '门店列表',
      parentId: 'storeManage',
      parentName: '门店管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/enterprise/storeManage/storeList'], resolve),
  },
  {
    path: '/enterprise/storeManage/storeCalibration',
    name: 'enterprise_storeCalibration',
    meta: {
      title: '门店校准',
      pageId: 'storeCalibration',
      pageName: '门店校准',
      parentId: 'storeManage',
      parentName: '门店管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/enterprise/storeManage/storeCalibration'], resolve),
  },
  {
    path: '/enterprise/companyMessage',
    name: 'enterprise_companyMessage',
    meta: {
      title: '企业通知',
      pageId: 'companyMessage',
      pageName: '企业通知',
      parentId: 'enterprise',
      parentName: '企业',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/enterprise/companyMessage/companyMessage'], resolve),
  },
  {
    path: '/enterprise/companyBigEvent',
    name: 'enterprise_companyBigEvent',
    meta: {
      title: '企业大事记',
      pageId: 'companyBigEvent',
      pageName: '企业大事记',
      parentId: 'enterprise',
      parentName: '企业',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/enterprise/companyBigEvent/companyBigEvent'], resolve),
  },
  {
    path: '/enterprise/brandBigEvent',
    name: 'enterprise_brandBigEvent',
    meta: {
      title: '品牌大事记',
      pageId: 'brandBigEvent',
      pageName: '品牌大事记',
      parentId: 'enterprise',
      parentName: '企业',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/enterprise/brandBigEvent/brandBigEvent'], resolve),
  },
  {
    path: '/enterprise/salesCommission/commissionConfig',
    name: 'enterprise_commissionConfig',
    meta: {
      title: '提成配置',
      pageId: 'commissionConfig',
      pageName: '提成配置',
      parentId: 'salesCommission',
      parentName: '销售提成',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/enterprise/salesCommission/commissionConfig'], resolve),
  },
  {
    path: '/enterprise/salesCommission/commissionDetail',
    name: 'enterprise_commissionDetail',
    meta: {
      title: '提成明细',
      pageId: 'commissionDetail',
      pageName: '提成明细',
      parentId: 'salesCommission',
      parentName: '销售提成',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/enterprise/salesCommission/commissionDetail'], resolve),
  },
];
